import { render, staticRenderFns } from "./newExamList.vue?vue&type=template&id=66441d33"
import script from "./newExamList.vue?vue&type=script&lang=js"
export * from "./newExamList.vue?vue&type=script&lang=js"
import style0 from "./newExamList.vue?vue&type=style&index=0&id=66441d33&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports